import BodyText, { BODY_TEXT_SIZES } from "@shared/ui/BodyText";
import Button, { BUTTON_SIZES } from "@shared/ui/Button";
import { DateInput } from "@shared/ui/Inputs";
import moment from "moment-timezone";
import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useIntl } from "react-intl";

import EmptySpace from "~/components/_emptySpace";
import { useAuth } from "~/components/general";

const CustomDateField = ({
  field,
  handleTextFieldSave,
  isEditable = true,
  dropdownClassname = "",
  dropAlignment = "left",
}) => {
  const { messages } = useIntl();
  const { user } = useAuth();

  const label = field?.isAdditionalField
    ? messages?.settings?.companyTabs?.customizeFields.additionalFields.labels[
        field?.slug
      ]
    : field?.label;
  const [formatedValue, setFormatedValue] = React.useState(field?.value);
  const triggerRef = useRef();
  const menuRef = useRef();
  const cTextField = useRef({ [field?.id]: formatedValue });

  const [isOpen, setIsOpen] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });

  const dateFormat = user.dateFormat || "DD-MM-YYYY";

  const toggle = () => {
    setIsOpen((prev) => {
      if (!prev && triggerRef.current) {
        const rect = triggerRef.current.getBoundingClientRect();
        setPos({ top: rect.bottom + 4, left: rect.left });
      }
      return !prev;
    });
  };

  const updateTextField = (textFields) => {
    toggle();
  };

  useEffect(() => {
    if (!isOpen) return;
    const onClick = (e) => {
      if (triggerRef.current?.contains(e.target)) return;
      if (menuRef.current?.contains(e.target)) return;
      setIsOpen(false);
      setFormatedValue(field?.value);
    };
    const onScroll = (e) => {
      if (menuRef.current?.contains(e.target)) return;
      setIsOpen(false);
    };
    const t = setTimeout(
      () => document.addEventListener("mousedown", onClick),
      0,
    );
    window.addEventListener("scroll", onScroll, true);
    return () => {
      clearTimeout(t);
      document.removeEventListener("mousedown", onClick);
      window.removeEventListener("scroll", onScroll, true);
    };
  }, [isOpen, field?.value]);

  useEffect(() => {
    if (field?.value) {
      setFormatedValue(field?.value);
      cTextField.current[field?._id] = field?.value;
    }
  }, [field?.value]);

  return (
    <>
      <div className="flex items-center gap-sm py-sm custom-field-row">
        <BodyText
          size={BODY_TEXT_SIZES.X_SMALL}
          color="text-secondary"
          title={label}
          className="w-[140px] flex-shrink-0 overflow-hidden text-ellipsis whitespace-nowrap no-styles"
        >
          {label}:
        </BodyText>
        <div className="flex-1 min-w-0">
          <div className={`c-dropdown ${isOpen ? "c-dropdown--shown" : ""}`}>
            <button
              ref={triggerRef}
              className={`c-textarea-btn u-width-100 ${
                !isEditable
                  ? "pointer-events-none !bg-transparent"
                  : "cursor-pointer"
              }`}
              onClick={() => {
                if (!isEditable) return;
                toggle();
              }}
            >
              <span className={field?.value ? "u-text-color-gray-v2-100" : ""}>
                {field?.value
                  ? moment(field.value).format(dateFormat)
                  : `${messages?.common?.emptyProperty}`}
              </span>
            </button>
            {isOpen &&
              createPortal(
                <div
                  ref={(node) => {
                    menuRef.current = node;
                    if (node) {
                      node.style.setProperty("position", "fixed", "important");
                      node.style.setProperty(
                        "top",
                        `${pos.top}px`,
                        "important",
                      );
                      node.style.setProperty(
                        "left",
                        `${pos.left}px`,
                        "important",
                      );
                      node.style.setProperty("z-index", "9999", "important");
                      node.style.setProperty(
                        "display",
                        "inline-flex",
                        "important",
                      );
                    }
                  }}
                  className={
                    "c-dropdown-menu customize-field-dropdown property-userDropdownMenu flex-col " +
                    dropdownClassname
                  }
                >
                  <div style={{ width: "100%" }}>
                    <EmptySpace height="8px" />
                    <div className="input-v2-wrapper mb-sm">
                      <DateInput
                        value={
                          formatedValue
                            ? moment(formatedValue, [
                                "YYYY-MM-DD",
                                "YYYY-M-D",
                              ]).format()
                            : ""
                        }
                        dropdownClassName={dropdownClassname}
                        showFormat={false}
                        format={dateFormat}
                        placeholder={dateFormat}
                        dropPosition="auto"
                        dropAlignment={dropAlignment}
                        onChange={(v) => {
                          const formatedDate = moment(v).format("YYYY-MM-DD");
                          if (formatedValue === formatedDate) {
                            setFormatedValue("");
                            cTextField.current[field?._id] = "";
                          } else {
                            setFormatedValue(formatedDate);
                            cTextField.current[field?._id] = formatedDate;
                          }
                        }}
                      />
                    </div>
                    <div className="flex justify-end">
                      <Button
                        size={BUTTON_SIZES.SMALL}
                        text={messages?.common?.save}
                        onClick={(e) => {
                          handleTextFieldSave(
                            e,
                            cTextField.current,
                            field?._id,
                            updateTextField,
                          );
                        }}
                      />
                    </div>
                  </div>
                </div>,
                document.body,
              )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomDateField;
